'use client'
import {
  __spreadProps,
  __spreadValues
} from "./chunk-E5AFJQUS.mjs";

// src/calendar/CalendarIcon.tsx
import { jsx } from "react/jsx-runtime";
var CalendarIcon = (props) => {
  return /* @__PURE__ */ jsx(
    "svg",
    __spreadProps(__spreadValues({
      width: "16",
      height: "16",
      viewBox: "0 0 16 16",
      fill: "none",
      xmlns: "http://www.w3.org/2000/svg"
    }, props), {
      children: /* @__PURE__ */ jsx(
        "path",
        {
          fillRule: "evenodd",
          clipRule: "evenodd",
          d: "M2 2H14V14H2V2ZM3.33333 3.33333V4.66667H12.6667V3.33333H3.33333ZM12.6667 6H3.33333V12.6667H12.6667V6ZM4.66667 7.33333H6.00667V8.66667H4.66667V7.33333ZM7.33333 7.33333H8.67333V8.66667H7.33333V7.33333ZM10 7.33333H11.34V8.66667H10V7.33333ZM4.66667 10H6.00667V11.3333H4.66667V10ZM7.33333 10H8.67333V11.3333H7.33333V10Z",
          fill: "currentColor"
        }
      )
    })
  );
};

// src/calendar/Duration.tsx
import { jsx as jsx2, jsxs } from "react/jsx-runtime";
var Duration = (props) => /* @__PURE__ */ jsxs(
  "svg",
  __spreadProps(__spreadValues({
    width: "24",
    height: "24",
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), {
    children: [
      /* @__PURE__ */ jsx2("g", { clipPath: "url(#clip0_7825_18631)", children: /* @__PURE__ */ jsx2(
        "path",
        {
          clipRule: "evenodd",
          d: "M15.6744 2.80859L16.4156 7.01197C16.6012 7.02319 16.7879 7.04184 16.9753 7.06818C20.8037 7.60622 23.471 11.1459 22.933 14.9743C22.3949 18.8026 18.8552 21.47 15.0269 20.9319C13.0113 20.6487 11.3176 19.5334 10.244 17.9821L3.33336 19.2006L0.902283 5.41332L15.6744 2.80859ZM9.32592 16.1131C9.01912 15.1463 8.9186 14.0974 9.0692 13.0258C9.23754 11.828 9.69971 10.7439 10.3726 9.836L3.91379 10.9749L4.95568 16.8837L9.32592 16.1131ZM3.56649 9.00525L14.3994 7.09512L14.0521 5.12551L3.21919 7.03564L3.56649 9.00525ZM16.6969 9.04871C13.9624 8.6644 11.434 10.5696 11.0497 13.3042C10.6654 16.0387 12.5707 18.5671 15.3052 18.9514C18.0398 19.3357 20.5681 17.4305 20.9524 14.6959C21.3367 11.9614 19.4315 9.43303 16.6969 9.04871ZM17.4089 11.1684L17.049 13.729L18.82 16.0793L17.2227 17.2829L14.9532 14.2711L15.4283 10.8901L17.4089 11.1684Z",
          fill: "currentColor"
        }
      ) }),
      /* @__PURE__ */ jsx2("defs", { children: /* @__PURE__ */ jsx2("rect", { width: "24", height: "24", fill: "currentColor" }) })
    ]
  })
);

export {
  CalendarIcon,
  Duration
};
//# sourceMappingURL=chunk-MMKYVCRY.mjs.map